export const environment = {
    production: true,
    mode: "tdp"
};



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/environments/environment.ts